<template>
  <div>
    <div class="row">
      <div class="col-12" v-if="!this.conf.isPro">
        <base-alert
          type="info"
          dismissible
          class="text-center"
          icon="tim-icons icon-spaceship"
        >
          <router-link class="pointer" tag="div" to="/pro">
            Découvrez le mode pro et bénéficiez de toutes les fonctionnalités de
            Moni.<br />
            1 mois offert avec le code <b>HELLOMONI !</b><br />
          </router-link>
        </base-alert>
      </div>

      <!-- Big Chart -->
      <div class="col-12" v-if="this.conf.history.length < 2">
        <welcome></welcome>
      </div>

      <div class="col-12" v-if="this.conf.history.length >= 2">
        <card type="chart">
          <template slot="header">
            <div class="row">
              <div class="col-sm-4 text-left">
                <h5 class="card-category">
                  Portefeuille
                </h5>
                <h2 class="card-title">Performances</h2>
              </div>
              <div class="col-sm-8 d-flex d-sm-block text-right">
                <div>
                  <div class="btn-group btn-group-toggle" data-toggle="buttons">
                    <label
                      v-for="(option, index) in bigLineChartCategories"
                      :key="option.name"
                      class="btn btn-sm btn-primary btn-simple"
                      :class="{ active: bigLineChart.activeIndex === index }"
                      :id="index"
                    >
                      <input
                        type="radio"
                        @click="initBigChart(index)"
                        name="options"
                        autocomplete="off"
                        :checked="bigLineChart.activeIndex === index"
                      />
                      <span class="d-none d-sm-block">{{ option.name }}</span>
                      <span class="d-block d-sm-none">
                        <i :class="option.icon"></i>
                      </span>
                    </label>
                  </div>
                  <span
                    @click="datesModal = true"
                    class="text-warning ml-3 pointer"
                  >
                    <i class="tim-icons icon-calendar-60"></i>
                  </span>
                  <span class="text-warning ml-2 pointer" @click="setDate(0)">
                    <small>YTD</small>
                  </span>
                  <span
                    v-if="!hebdoView"
                    class="text-warning ml-2 pointer"
                    @click="setDate(1)"
                  >
                    <small>1M</small>
                  </span>
                  <span
                    v-if="!hebdoView"
                    class="text-warning ml-2 pointer"
                    @click="setDate(3)"
                  >
                    <small>3M</small>
                  </span>
                  <span class="text-warning ml-2 pointer" @click="setDate(6)">
                    <small>6M</small>
                  </span>
                  <span class="text-warning ml-2 pointer" @click="setDate(12)">
                    <small>1A</small>
                  </span>
                  <span
                    v-if="hebdoView"
                    class="text-warning ml-2 pointer"
                    @click="setDate(3 * 12)"
                  >
                    <small>3A</small>
                  </span>
                  <span
                    v-if="hebdoView"
                    class="text-warning ml-2 pointer"
                    @click="setDate(5 * 12)"
                  >
                    <small>5A</small>
                  </span>
                </div>
                <div class="mt-1">
                  <small
                    class="text-info pointer"
                    @click="
                      displayIndex = !displayIndex;
                      initBigChart(index);
                    "
                    v-if="hebdoView && mode === 'pea'"
                  >
                    {{
                      displayIndex ? "Retirer le CAC40" : "Comparer au CAC40"
                    }}
                  </small>
                </div>
              </div>
            </div>
          </template>
          <div class="chart-area">
            <line-chart
              style="height: 100%"
              ref="bigChart"
              :chart-data="bigLineChart.chartData"
              :gradient-colors="bigLineChart.gradientColors"
              :gradient-stops="bigLineChart.gradientStops"
              :extra-options="bigLineChart.extraOptions"
              @point-clicked="pointClicked"
            >
            </line-chart>
          </div>
          <!-- <div class="text-center" v-if="limit < 15">
            <small v-if="limit > 0">
              Vous atteindrez la limite de stockage des 
              performances {{this.hebdoView?'hebdo':'daily'}} dans {{limit}} jours.
              <br>Pensez à télécharger l'historique depuis votre profil pour le conserver.
            </small>
            <small v-if="limit <= 0">
              Vous avez atteint la limite de stockage des performances {{this.hebdoView?'hebdo':'daily'}}.
              <br>Pensez à télécharger l'historique depuis votre profil pour le conserver.
            </small>
          </div> -->
        </card>
      </div>

      <!-- Stats Cards -->
      <div
        class="col-lg-3 col-md-6"
        v-for="card in statsCards"
        :key="card.key"
        v-bind:class="{ 'col-lg-4': conf.hideStop, 'd-none': card.hide }"
        @click="card.click && card.click()"
      >
        <stats-card
          :title="card.title"
          :title-class="hideAmount ? 'text-blur' : ''"
          :sub-title="card.subTitle"
          :type="card.type"
          :icon="card.icon"
          :navTo="card.navTo"
        >
          <div slot="footer" v-html="card.footer"></div>
        </stats-card>
      </div>

      <div class="col-lg-12">
        <card class="card">
          <div slot="header">
            <div class="d-inline-block">
              <h5 class="card-title mb-0 d-inline-block">
                Positions actuelles
              </h5>
              <br />
              <h4 class="card-title mb-0 d-inline-block">
                <span v-bind:class="{ 'text-blur': hideAmount }">{{
                  invested | currency({ symbol: cur })
                }}</span>
                investis sur {{ this.conf.positions.length }} valeur{{
                  this.conf.positions.length > 1 ? "s" : ""
                }}
              </h4>
            </div>
            <div
              class="float-sm-right d-inline-block text-sm-right"
              v-if="totalInvestedCapital"
            >
              <el-tooltip
                :content="
                  protectedCapitalPercent +
                    '% du capital investi protégé, soit ' +
                    protectedPV +
                    ' de ± values.'
                "
                effect="light"
                :open-delay="200"
                placement="top"
              >
                <h5 class="float-sm-right d-inline-block card-title mb-0">
                  Capital protégé :
                  <b v-bind:class="{ 'text-blur': hideAmount }">{{
                    protectedCapital | currency({ symbol: cur })
                  }}</b>
                </h5>
              </el-tooltip>
              <br />
              <h5 class="d-inline-block card-title mb-0">
                ± value latente :
                <b
                  class="text-success"
                  v-bind:class="{ 'text-danger': pv < 0 }"
                >
                  <b v-if="!hideAmount">{{ pv | currency({ symbol: cur }) }}</b>
                  <span
                    class="quote-percent text-center"
                    v-bind:class="{ negative: pv < 0 }"
                    >{{
                      parseFloat((pv / totalInvestedCapital) * 100).toFixed(2)
                    }}%</span
                  >
                </b>
              </h5>
            </div>
          </div>
          <div class="table-responsive">
            <position-table :hideAmount="hideAmount"></position-table>
            <div class="text-right" style="margin-top: -15px">
              <small
                class="text-info pointer"
                @click="hideAmount = !hideAmount"
              >
                {{
                  hideAmount ? "Afficher les montants" : "Cacher les montants"
                }}
              </small>
            </div>
          </div>
        </card>
      </div>

      <!-- <div class="col-lg-12">
        <position-detail 
          v-for="position in this.conf.positions"
          :key="position.isin"
          :position="position"
        ></position-detail>
      </div> -->
    </div>
    <modal :show-close="true" :show.sync="datesModal">
      <h4>Afficher entre les dates :</h4>
      <div class="row">
        <div class="col-6">
          <base-input>
            <el-date-picker
              type="date"
              placeholder="Date de début"
              v-model="fromDate"
            >
            </el-date-picker>
          </base-input>
        </div>
        <div class="col-6">
          <base-input>
            <el-date-picker
              type="date"
              placeholder="Date de fin"
              v-model="toDate"
            >
            </el-date-picker>
          </base-input>
        </div>
        <div class="col-12">
          <div class="text-center">
            <span
              @click="changeDates"
              class="mt-3 text-center btn btn-primary btn-simple"
              >Enregistrer</span
            >
          </div>
        </div>
      </div>
    </modal>
    <modal :show-close="true" :show.sync="pointModal">
      <div>
        <h3 class="text-primary mb-0">Modifier l'historique</h3>
        <small class="text-muted"
          >Modification de la valeur du
          {{ $moment(point.t * 1000).format("ll") }}</small
        >
        <div v-if="point">
          <base-input
            name="pointCapital"
            required
            type="number"
            label="Capital initial"
            v-model="point.ic"
          ></base-input>
          <base-input
            name="pointCash"
            required
            type="number"
            label="Liquidités"
            v-model="point.cash"
          ></base-input>
          <base-input
            name="donationValue"
            required
            type="number"
            label="Montant investi"
            v-model="point.pos"
          ></base-input>
          <div class="text-center">
            <span
              @click="updateHisto"
              class="mt-3 text-center btn btn-primary btn-simple"
              >Modifier les valeurs</span
            >
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import LineChart from "@/components/Charts/LineChart";
import * as chartConfigs from "@/components/Charts/config";
import TaskList from "./TaskList";
import Welcome from "./Welcome";
import PositionTable from "./PositionTable";
import StatsCard from "src/components/Cards/StatsCard";
import config from "@/config";
import { Modal, BaseAlert } from "@/components";
import { mapGetters } from "vuex";
import PositionDetail from "./PositionDetail";

import { getQuoteWeeklyHistory } from "../../dao/firestore";
import { DatePicker } from "element-ui";

let bigChartData = [];
let bigChartDatasetOptions = {
  fill: true,
  borderColor: config.colors.primary,
  borderWidth: 2,
  borderDash: [],
  borderDashOffset: 0.0,
  pointBackgroundColor: config.colors.primary,
  pointBorderColor: "rgba(255,255,255,0)",
  pointHoverBackgroundColor: config.colors.primary,
  pointBorderWidth: 20,
  pointHoverRadius: 4,
  pointHoverBorderWidth: 15,
  pointRadius: 4
};
let bigChartDatasetIndexOptions = {
  ...bigChartDatasetOptions,
  fill: false,
  borderColor: config.colors.info,
  pointBackgroundColor: config.colors.info,
  pointHoverBackgroundColor: config.colors.info,
  pointRadius: 2
};

export default {
  components: {
    [DatePicker.name]: DatePicker,
    LineChart,
    StatsCard,
    TaskList,
    PositionTable,
    PositionDetail,
    Welcome,
    Modal,
    BaseAlert
  },
  data() {
    return {
      hideAmount: false,
      hebdoView: false,
      displayIndex: true,
      invested: 0,
      pv: 0,
      limit: 1000,
      protectedCapital: 0,
      protectedCapitalPercent: 0,
      protectedPV: 0,
      totalInvestedCapital: 0,
      statsCards: [
        {
          key: "totalPortfolio",
          title: "4 563€",
          subTitle: "Portefeuille total",
          type: "success",
          icon: "tim-icons icon-money-coins",
          footer:
            '<span class="text-success">+13%</span> par rapport au capital initial'
        },
        {
          key: "evolution",
          title: "+312€",
          subTitle: "Performance du jour",
          type: "primary",
          icon: "tim-icons icon-notes",
          footer:
            '<span class="text-success">+2.16%</span> par rapport à la semaine dernière',
          click: this.switchHebdo
        },
        {
          key: "cash",
          title: "1600€",
          subTitle: "Couverture disponible",
          type: "info",
          icon: "tim-icons icon-delivery-fast",
          footer: "Liquidités disponibles",
          navTo: "pages/user"
        },
        {
          key: "stops",
          title: "NA",
          subTitle: "Stop Losses",
          type: "danger",
          icon: "tim-icons icon-simple-remove",
          footer: 'Stop à vérifier - <b class="text-danger">en Dév!</b>'
        }
      ],
      bigLineChart: {
        activeIndex: 0,
        chartData: {
          datasets: [
            {
              ...bigChartDatasetOptions,
              yAxisID: "y-axis-1",
              data: bigChartData[0]
            },
            {
              ...bigChartDatasetIndexOptions,
              yAxisID: "y-axis-2",
              data: bigChartData[0]
            }
          ]
        },
        extraOptions: {
          ...chartConfigs.purpleChartOptions,
          onClick: this.handle
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        categories: []
      },
      point: { ic: 0, t: 0, pos: 0, cash: 0 },
      pointModal: false,
      datesModal: false,
      fromDate: null,
      toDate: null
    };
  },
  computed: {
    ...mapGetters({
      livelist: "instruments/livelist",
      conf: "auth/conf",
      mode: "auth/mode"
    }),
    enableRTL() {
      return this.$route.query.enableRTL;
    },
    isRTL() {
      return this.$rtl.isRTL;
    },
    cur() {
      return this.mode === "pea" ? "€" : "$";
    },
    bigLineChartCategories() {
      return [
        { name: "Portefeuille total", icon: "tim-icons icon-money-coins" },
        { name: "Gains " + this.cur, icon: "tim-icons icon-notes" },
        { name: "Gains %", icon: "tim-icons icon-notes" },
        { name: "Perf cumulée %", icon: "tim-icons icon-simple-add" }
      ];
    }
  },
  methods: {
    pointClicked(data) {
      const point = this.bigLineChart.chartData.datasets[0].data[data.index];
      const his = this.conf.history.find(h => {
        return h.t - (h.t % (24 * 60 * 60)) == +point.x / 1000;
      });
      if (his) {
        this.point = his;
        this.pointModal = true;
      }
    },
    updateHisto() {
      this.conf.history[
        this.conf.history.findIndex(el => el.t === this.point.t)
      ] = {
        ic: parseFloat(this.point.ic) || 0,
        t: this.point.t,
        pos: parseFloat(this.point.pos) || 0,
        cash: parseFloat(this.point.cash) || 0
      };
      this.$store.dispatch("auth/updateconf", { history: this.conf.history });
      this.pointModal = false;
    },
    async changeDates() {
      this.datesModal = false;
      await this.initBigChart();
    },
    async initBigChart(index) {
      if (index != undefined) this.bigLineChart.activeIndex = index;
      const histo = this.getHistory();
      let data = histo.map((h, i) => {
        let value = null;
        if (this.bigLineChart.activeIndex === 0) {
          // valeur du portefeuille
          value = Number(h.pos + h.cash).toFixed(2);
        } else if (this.bigLineChart.activeIndex === 1) {
          // diff en euro
          if (i === 0) value = 0;
          else {
            const p = histo[i - 1];
            const dic = h.ic && p.ic ? h.ic - p.ic : 0;
            value = Number(h.pos + h.cash - (p.pos + p.cash) - dic).toFixed(2);
          }
        } else if (this.bigLineChart.activeIndex === 2) {
          // diff en %
          if (i === 0) value = 0;
          else {
            const p = histo[i - 1];
            const dic = h.ic && p.ic ? h.ic - p.ic : 0;
            value = Number(
              ((h.pos + h.cash - (p.pos + p.cash) - dic) / (p.pos + p.cash)) *
                100
            ).toFixed(2);
          }
        } else if (this.bigLineChart.activeIndex === 3) {
          // diff en %
          if (i === 0) value = 0;
          else {
            value = h.ic
              ? Number(((h.pos + h.cash - h.ic) / h.ic) * 100).toFixed(2)
              : 0;
          }
        }
        // Pour les cryptos, on affiche à l'heure du jour
        // Pour les autres, on se cale sur le début de la journée
        const timestamp =
          this.mode === "crypto"
            ? new Date(h.t * 1000)
            : new Date((h.t - (h.t % (24 * 60 * 60))) * 1000);
        return {
          x: timestamp,
          y: value
        };
      });

      let indexData = [];
      if (this.displayIndex && this.hebdoView && this.mode === "pea") {
        const indexHisto = (await this.getIndexHisto()).filter(
          h => h[0] > +data[0].x - 12 * 3600000
        );
        indexData = indexHisto.map((h, i) => {
          let value = null;
          if (this.bigLineChart.activeIndex === 0) {
            value = h[4];
          } else if (this.bigLineChart.activeIndex === 2) {
            if (i === 0) value = 0;
            else {
              const p = indexHisto[i - 1];
              value = Number(((h[4] - p[4]) / p[4]) * 100).toFixed(2);
            }
          }
          return {
            x: new Date(h[0]),
            y: value
          };
        });
      }

      if (data.length > 0) {
        const dStart = new Date();
        let dayLimit = (dayLimit = this.hebdoView ? 1825 : 365);
        dStart.setDate(dStart.getDate() - dayLimit);
        this.limit = parseInt((+data[0].x - dStart) / (1000 * 3600 * 24));
      }

      let chartData = {
        datasets: [
          {
            ...bigChartDatasetOptions,
            yAxisID: "y-axis-1",
            data: data
          },
          {
            ...bigChartDatasetIndexOptions,
            yAxisID:
              this.bigLineChart.activeIndex === 0 ? "y-axis-2" : "y-axis-1",
            data: indexData
          }
        ]
      };
      this.bigLineChart.chartData = chartData;
      if (this.$refs.bigChart) this.$refs.bigChart.updateGradients(chartData);
    },
    async setDate(month) {
      this.fromDate = new Date();
      this.toDate = new Date();
      if (month == 0) {
        this.fromDate.setMonth(0);
        this.fromDate.setDate(0);
      } else {
        this.fromDate.setMonth(this.fromDate.getMonth() - month);
      }
      await this.initBigChart();
    },
    async switchHebdo() {
      if (this.hebdoView || this.getHistory().length > 7) {
        this.hebdoView = !this.hebdoView;
        this.fromDate = new Date();
        this.fromDate.setDate(
          this.fromDate.getDate() - (this.hebdoView ? 365 : 60)
        );
        this.toDate = new Date();
        await this.initBigChart();
        this.updateStats();
      }
    },
    getHistory() {
      if (!this.toDate) {
        this.fromDate = new Date();
        this.fromDate.setDate(this.fromDate.getDate() - 60);
        this.toDate = new Date();
      }
      var t = new Date();
      const toToday =
        this.toDate.getDate() == t.getDate() &&
        this.toDate.getMonth() == t.getMonth() &&
        this.toDate.getFullYear() == t.getFullYear();

      let filterHisto = this.conf.history.filter(h => {
        const dh = new Date(h.t * 1000);
        const endOfWeek = this.mode === "crypto" ? 0 : 5;
        if (this.hebdoView && dh.getDay() != endOfWeek) return false;
        else return dh > this.fromDate && dh < this.toDate;
      });
      if (
        (t.getDay() != 6 && t.getDay() != 0 && toToday) ||
        this.mode === "crypto"
      ) {
        filterHisto.push({
          t: +new Date() / 1000,
          cash: this.conf.cash,
          ic: this.conf.initialCapital,
          pos:
            this.$store.getters["instruments/totalPortfolio"](this.conf) -
            this.conf.cash
        });
      }
      return filterHisto;
    },
    async getIndexHisto() {
      const ind = this.$store.getters["instruments/indexes"].find(
        x => x.sy === "PXA"
      );
      return await getQuoteWeeklyHistory(ind);
    },
    updateStats() {
      const positions = this.$store.getters["instruments/addInfoToList"](
        this.conf.positions
      ).filter(p => !!p.info);

      const initial = this.conf.initialCapital;
      const current = this.$store.getters["instruments/totalPortfolio"](
        this.conf
      );
      let previous = current;
      const histo = this.getHistory();
      if (histo.length >= 2) {
        const pp = histo[histo.length - 2];
        previous = pp.cash + pp.pos + (initial - pp.ic);
      }

      // Total investi
      this.invested = current - this.conf.cash;
      // todo : placer stop via conf
      const stopLimit = this.mode === "crypto" ? 25 : 10;
      let stopToUpdate = 0;
      this.pv = 0;
      this.protectedCapital = 0;
      this.totalInvestedCapital = 0;

      positions.map(c => {
        const st = ((c.info.li.last - c.stop) / c.info.li.last) * 100;
        if (st > stopLimit) {
          stopToUpdate++;
        }
        this.protectedCapital += c.stop * c.quantity;
        this.totalInvestedCapital += c.value * c.quantity;
        this.pv += (c.info.li.last - c.value) * c.quantity;
      });
      this.protectedCapitalPercent = parseFloat(
        (this.protectedCapital / this.totalInvestedCapital) * 100
      ).toFixed(1);
      this.protectedPV = this.$options.filters.currency(
        this.protectedCapital - this.totalInvestedCapital,
        { symbol: this.cur }
      );

      this.statsCards[0].title = this.$options.filters.currency(current, {
        symbol: this.cur
      });
      this.statsCards[0].footer =
        `<span class="text-${current > initial ? "success" : "danger"} ${
          this.hideAmount ? "text-blur" : ""
        }">${this.$options.filters.currency(current - initial, {
          symbol: this.cur
        })}</span>` +
        `<span class="quote-percent text-center ${
          current > initial ? "" : "negative"
        }">${Number(((current - initial) / initial) * 100).toFixed(
          2
        )}%</span>` +
        ` / capital initial`;

      this.statsCards[1].title = this.$options.filters.currency(
        current - previous,
        { symbol: this.cur }
      );
      this.statsCards[1].subTitle =
        "Performance " + (this.hebdoView ? "hebdo" : "du jour");
      let footerPerf = `<span class="text-${
        current > previous ? "success" : "danger"
      }">${Number(((current - previous) / previous) * 100).toFixed(
        2
      )}%</span> / dernière ${this.hebdoView ? "semaine" : "séance"}`;
      if (this.hebdoView || histo.length > 7)
        footerPerf += `<span class="text-right text-primary float-right" style="cursor:pointer">voir ${
          this.hebdoView ? "daily" : "hebdo"
        }</span>`;

      this.statsCards[1].footer = footerPerf;

      this.statsCards[2].title = this.$options.filters.currency(
        this.conf.cash,
        { symbol: this.cur }
      );
      this.statsCards[2].footer = `Compte liquide à <b>${Number(
        (this.conf.cash / current) * 100
      ).toFixed(
        1
      )}%</b> <span class="text-right text-primary float-right" style="cursor:pointer">modifier</span>`;

      this.statsCards[3].title = "" + stopToUpdate;
      this.statsCards[3].footer = `<b>${stopToUpdate}</b> stop à vérifier`;
      if (this.conf.hideStop) this.statsCards[3].hide = true;
    }
  },
  async mounted() {
    if (this.conf) {
      this.updateStats();
      await this.initBigChart();
    }
  },
  beforeDestroy() {},
  watch: {
    async livelist(newValue, oldValue) {
      this.updateStats();
      await this.initBigChart();
    },
    async conf(newValue, oldValue) {
      this.updateStats();
      await this.initBigChart();
    },
    async hideAmount(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.bigLineChart.activeIndex = 2;
      } else if (!newValue && newValue !== oldValue) {
        this.bigLineChart.activeIndex = 0;
      }
      this.updateStats();
      await this.initBigChart();
    }
  },
  metaInfo() {
    return {
      title: "Dashboard Peamoni"
    };
  }
};
</script>
<style></style>
